import React from 'react';
import { IconBox, IconProps } from 'src/lib/IconBox';

// eslint-disable-next-line import/no-default-export,react/display-name
export default (props: IconProps) => (
  <IconBox viewBox="0 16 64 32" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.33257 41.0831C11.3726 41.0831 13.0264 39.4293 13.0264 37.3892C13.0264 35.3491 11.3726 33.6953 9.33257 33.6953C7.2925 33.6953 5.6387 35.3491 5.6387 37.3892C5.6387 39.4293 7.2925 41.0831 9.33257 41.0831ZM9.33257 41.9249C11.8376 41.9249 13.8683 39.8942 13.8683 37.3892C13.8683 34.8842 11.8376 32.8535 9.33257 32.8535C6.82758 32.8535 4.79688 34.8842 4.79688 37.3892C4.79688 39.8942 6.82758 41.9249 9.33257 41.9249Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.33385 39.9968C10.7727 39.9968 11.9392 38.8303 11.9392 37.3915C11.9392 35.9526 10.7727 34.7862 9.33385 34.7862C7.89498 34.7862 6.72854 35.9526 6.72854 37.3915C6.72854 38.8303 7.89498 39.9968 9.33385 39.9968ZM9.33385 40.8386C11.2376 40.8386 12.781 39.2953 12.781 37.3915C12.781 35.4877 11.2376 33.9443 9.33385 33.9443C7.43005 33.9443 5.88672 35.4877 5.88672 37.3915C5.88672 39.2953 7.43005 40.8386 9.33385 40.8386Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M46.8871 38.2979H13.8672V37.4561H46.8871V38.2979Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M47.2487 40.1133L12.7773 40.1133L12.7773 39.2715L47.2487 39.2715L47.2487 40.1133Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M51.063 41.0831C53.1031 41.0831 54.7569 39.4293 54.7569 37.3892C54.7569 35.3491 53.1031 33.6953 51.063 33.6953C49.023 33.6953 47.3692 35.3491 47.3692 37.3892C47.3692 39.4293 49.023 41.0831 51.063 41.0831ZM51.063 41.9249C53.568 41.9249 55.5987 39.8942 55.5987 37.3892C55.5987 34.8842 53.568 32.8535 51.063 32.8535C48.558 32.8535 46.5273 34.8842 46.5273 37.3892C46.5273 39.8942 48.558 41.9249 51.063 41.9249Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M51.0585 39.9968C52.4973 39.9968 53.6638 38.8303 53.6638 37.3915C53.6638 35.9526 52.4973 34.7862 51.0585 34.7862C49.6196 34.7862 48.4532 35.9526 48.4532 37.3915C48.4532 38.8303 49.6196 39.9968 51.0585 39.9968ZM51.0585 40.8386C52.9623 40.8386 54.5056 39.2953 54.5056 37.3915C54.5056 35.4877 52.9623 33.9443 51.0585 33.9443C49.1547 33.9443 47.6113 35.4877 47.6113 37.3915C47.6113 39.2953 49.1547 40.8386 51.0585 40.8386Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.559 23.8419L17.5848 29.1033H14.775C8.53058 29.1033 3.23815 31.4643 1.2126 32.7312L0.884295 38.3123L5.59612 39.1537L5.44814 39.9824L0 39.0095L0.397237 32.2565L0.574067 32.1404C2.56524 30.8337 8.14755 28.2614 14.775 28.2614H17.408L29.3822 23L29.4706 23L29.4706 23.4209C29.4706 23 29.4705 23 29.4706 23L46.7426 23C46.8559 23 46.9893 23.0229 47.1182 23.0511C47.2544 23.0809 47.4145 23.1233 47.5921 23.1751C47.9477 23.2788 48.3913 23.4254 48.8875 23.5991C49.8808 23.9467 51.1028 24.4092 52.2881 24.8701C53.4741 25.3313 54.6269 25.7924 55.4829 26.1381C55.9109 26.311 56.2649 26.4551 56.512 26.5559L56.7983 26.6731L56.8472 26.6932L61.159 27.2322L63.0929 29.4307V32.7028L64 33.7914V37.1371L62.9365 39.0513L55.6498 39.9855L55.5427 39.1505L62.4073 38.2705L63.1582 36.919V34.0962L62.251 33.0076V29.7483L60.7378 28.0279L56.6311 27.5145L56.579 27.4931L56.4788 27.4519L56.1937 27.3353C55.9475 27.2348 55.5945 27.0911 55.1676 26.9187C54.3137 26.5738 53.1645 26.1142 51.983 25.6547C50.8006 25.1949 49.5892 24.7366 48.6094 24.3937C48.1191 24.222 47.6913 24.0809 47.3564 23.9832C47.1887 23.9343 47.0487 23.8976 46.9383 23.8735C46.8205 23.8477 46.7607 23.8418 46.7426 23.8418L29.559 23.8419Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M49.2565 29.1034L19.8652 29.6477L19.8496 28.806L49.2409 28.2617L49.2565 29.1034Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M59.0754 29.3506H62.3073V30.1924H59.3707L58.9461 30.5321L60.486 32.072H62.3073V32.9138H60.1373L57.6858 30.4623L59.0754 29.3506ZM2.57585 32.072H6.60895L6.78913 32.8733L3.25646 34.5467H0.803251V33.7049H3.06717L4.73711 32.9138H2.65921L0.885799 33.2685L0.720703 32.443L2.57585 32.072Z"
    />
  </IconBox>
);
